import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#1D2939",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M11.996.75H5.254a4.5 4.5 0 0 0-4.5 4.5v13.5a4.5 4.5 0 0 0 4.5 4.5h13.492a4.5 4.5 0 0 0 4.5-4.5V5.25a4.5 4.5 0 0 0-4.5-4.5h-6.75M12 5.875A1.125 1.125 0 0 0 10.88 7v3.875H7.003a1.125 1.125 0 0 0 0 2.25h3.875V17c0 .62.502 1.122 1.121 1.125A1.125 1.125 0 0 0 13.12 17v-3.875h3.876a1.125 1.125 0 1 0 0-2.25H13.12V7c0-.62-.502-1.123-1.12-1.125",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }